/*
 * @Author: Roman
 * @Date: 2022-12-14 11:15:49
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-12-15 09:56:15
 * @FilePath: \qpmn-site\src\app\pages\products\detail\product-detail-anonymous.ts
 * @Description: 
 */
import { IProductDetailController, IProductDetailState } from "./product-detail";
import { IProductDetailObjectTree, ProductDetailObjectTree } from "./product-detail-object-tree";
import { PropertyModel } from "@modules/property-model/model/domain/PropertyModel";
import { ProductTypeEnum } from "../../../modules/product/model/dto/ProductTypeEnum";
export class ProductDetailAnonymous implements IProductDetailState {

    constructor(private userManager: qpmn.user.IUserManager, public $objectTree: IProductDetailObjectTree) { }

    public isLogin: boolean = false;
    protected context: IProductDetailController;

    public setContext(context: IProductDetailController): void {
        this.context = context;
    }

    // public addStoreProduct(productType: ProductTypeEnum): void {
    //     // 提示需要登录
    //     this.userManager.invalidPrompt();
    //     // throw new Error("Method not implemented.");
    // }

    public selectedStore(propertyModelId: number | undefined): void {
        this.context.qpLoading.open()
        this.context.qpLoading.close();
        // 提示需要登录
        this.userManager.invalidPrompt();
    }

    // public creatPropertyModel(profileModels: Array<qpmn.product.model.domain.propertyModel.IProfileModel>): qpmn.product.model.domain.propertyModel.IPropertyModel {
    //     if (!this.$objectTree.configurableProductId) {
    //         throw new Error("");
    //     }
    //     let pm = new PropertyModel();
    //     pm.configurableProductId = this.$objectTree.configurableProductId;
    //     pm.profileModels = profileModels;
    //     return pm
    // }
}